import type React from 'react';
import type { UIChildrenMappingProps } from '@components/types';
import mapChildren from '@src/mapChildren';

import DescriptionText from '../../DescriptionText';
import ErrorText from '../../ErrorText';

interface SectionBodyProps extends UIChildrenMappingProps {
  isHidden: boolean;
  item: any;
  ownKey: any;
  descriptionText: string;
  className?: string;
}

const SectionBody: React.FC<SectionBodyProps> = ({
  autoGrow,
  ctx,
  item,
  onChange,
  ownKey,
  validationErrors,
  descriptionText,
  showQuestionId,
  showQuestionKey,
  isReadOnly = false,
  isDisabled,
  hideErrors,
}) => {
  const error =
    validationErrors &&
    validationErrors.find((err) => ownKey === err.instancePath.split('.').filter(Boolean).join('.'));

  return (
    <>
      {descriptionText && <DescriptionText className="mt-4 mb-8">{descriptionText}</DescriptionText>}
      <>
        {mapChildren({
          autoGrow,
          ctx,
          onChange,
          parentKey: ownKey,
          parentSchema: item,
          validationErrors,
          showQuestionId,
          showQuestionKey,
          isReadOnly,
          isDisabled,
          hideErrors,
        })}
      </>
      {error && error.keyword === 'total100' && <ErrorText className="mb-4">{error.message}</ErrorText>}
    </>
  );
};

export default SectionBody;
